import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn:  process.env.REACT_APP_SENTRY_DSN, // Remplace par ton DSN Sentry
  integrations: [
    Sentry.replayIntegration(), // Pour le session replay (optionnel)
    Sentry.browserTracingIntegration(), // Pour le tracing moderne
  ],
  tracesSampleRate: 1.0,
  environment: process.env.REACT_APP_MODE ,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Une erreur est survenue.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
